import classNames from 'classnames';
import React from 'react';

import {Image} from '@udemy/react-core-components';

import {PersonalPlanLandingPageProps} from '../../personal-plan-landing-page-body.react-component';
import styles from './value-prop.module.less';

export interface ValuePropProps extends PersonalPlanLandingPageProps {
    className?: string;
    content: string;
    heading: string;
    imgSrc: {
        desktopSrc: string;
        desktopSrc2x: string;
        mobileSrc: string;
    };
    slogan: string;
}

export const ValueProp = ({
    imgSrc,
    slogan,
    heading,
    content,
    className,
    isPPLPRevamp,
}: ValuePropProps) => {
    const {mobileSrc, desktopSrc, desktopSrc2x} = imgSrc;

    return (
        <div
            className={classNames(className, styles['value-prop'], {
                [styles.revamp]: isPPLPRevamp,
            })}
        >
            <div className={classNames(styles['column'], styles['image-container'])}>
                <Image
                    src={mobileSrc}
                    width={620}
                    height={350}
                    alt={''}
                    data-purpose="mobile-image"
                    className="hide-on-desktop"
                />
                <Image
                    src={desktopSrc}
                    srcSet={`${desktopSrc} 1x, ${desktopSrc2x} 2x`}
                    width={620}
                    height={350}
                    alt={''}
                    data-purpose="desktop-image"
                    className="hide-on-mobile"
                />
            </div>

            <div className={classNames(styles['column'], styles['text'])}>
                <h3 className={classNames(!isPPLPRevamp && 'ud-heading-md')}>{slogan}</h3>
                <h2 className={classNames(!isPPLPRevamp && 'ud-heading-serif-xl', styles['title'])}>
                    {heading}
                </h2>
                <p className="ud-text-md">{content}</p>
            </div>
        </div>
    );
};
